<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      ref="table"
      :max-items="itemsPerPage"
      search
      :data="requests"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div @click="refresh()"
               class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th width="10%" sort-key="ref">N° TICKET</vs-th>
        <vs-th width="20%" sort-key="title">Demande</vs-th>
        <vs-th width="20%" sort-key="type">Type</vs-th>
        <vs-th width="20%" sort-key="status">Statut</vs-th>
        <vs-th width="5%" sort-key="priority">Priorité</vs-th>
        <vs-th width="10%" sort-key="user_assign">Assigné par</vs-th>
        <vs-th width="10%" sort-key="user_owner">Assigné à</vs-th>
        <vs-th width="5%" sort-key="group">Envoyé par</vs-th>
        <vs-th width="10%" sort-key="created_at">Date</vs-th>
        <vs-th width="10%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td> {{ tr.ref }}</vs-td>
          <vs-td >
            <span class="">{{ tr.title }} </span><vs-chip v-if="tr.fromEmail">Email</vs-chip>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.type | title }}</p>
          </vs-td>

          <vs-td>
            <vs-chip>{{ tr.status | title}}</vs-chip>
          </vs-td>

          <vs-td>
            <vs-chip
              :color="getPriorityColor(tr.priority)"
              class="product-order-status"
            >{{ tr.priority | title }}</vs-chip
            >
          </vs-td>

          <vs-td>
            <p class="group">{{ tr.user_assign }}</p>
          </vs-td>

          <vs-td>
            <p class="group">{{ tr.user_owner }}</p>
          </vs-td>

          <vs-td>
            <p class="group">{{ tr.group }}</p>
          </vs-td>

          <vs-td>
            <p class="product-price">{{ tr.created_at | title }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <div class="flex">
              <div @click="goToSingle(tr.id, tr.has_proved)"  class="flex">
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                /> Détails
              </div>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
  </div>
</template>

<script>
  var base_self;

  export default {
    data() {
      return {
        dispatcher: false,
        last_page: 1,
        page: 1,
        filterPrompt: false,
        stringSearch: {},
        requestDatas: [],
        itemsPerPage: 50,
        isMounted: false,
        profile: ''
      };
    },
    watch: {
      page (value) {
        base_self.getRequests(value);
      },
    },
    computed: {
      isAdmin() {
        return this.$store.state.AppActiveUser.userRole === 'admin'
      },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx;
        }
        return 0;
      },
      requests() {
        return base_self.requestDatas;
      },
      queriedItems() {
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.requests.length;
      },
    },
    methods: {
      refresh(){
        base_self.getRequests(1);
      },

      getPriorityColor(status) {
        status = status.toLowerCase();
        if (status == "normale") return "primary";
        if (status == "basse") return "success";
        if (status == "haute") return "danger";
        return "primary";
      },
      getProgressionColor(num) {
        if (num > 90) return "success";
        if (num > 70) return "primary";
        if (num >= 50) return "warning";
        if (num < 50) return "danger";
        return "primary";
      },
      goToSingle(id, el) {
        let t = el ? 1 : 2
        this.$router.push('/requests/' + id + '/detail/'+t)
      },
      async getRequests (page) {
        base_self.$vs.loading()
        base_self.$http.get('/folders/requests/'+this.$route.params.id+'/details?page='+page).then((response) =>{
          base_self.last_page = response.data.last_page;
          base_self.requestDatas = response.data.data;
          base_self.$vs.loading.close()
        }).catch((error) => {
          base_self.$vs.loading.close()
        })
      },
    },
    created() {
      base_self = this;
      window.RequestsApp = this;
    },
    async mounted() {
      this.isMounted = true;
      this.dispatcher = window.GETCCMT.$store.state.is_dispatcher()
      this.profile = window.GETCCMT.$store.state.AppActiveUser.profile_id
      base_self.getRequests(base_self.page);
    }
  };
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 0.5rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
          td {
            padding: 20px;
            &:first-child {
              border-top-left-radius: 0.5rem;
              border-bottom-left-radius: 0.5rem;
            }
            &:last-child {
              border-top-right-radius: 0.5rem;
              border-bottom-right-radius: 0.5rem;
            }
          }
          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check {
          padding: 0 15px !important;
        }
        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: right;
      }
    }
  }
</style>
